// AccountsTable.js

import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";

export default function AccountsTable({
  accounts,
  onEdit,
  onMarkMain,
  onDelete,
}) {
  return (
    <Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>IBAN</TableCell>
            <TableCell>BIC</TableCell>
            <TableCell>Hauptkonto</TableCell>
            <TableCell>Aktionen</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {accounts.map((acc) => (
            <TableRow key={acc._id}>
              <TableCell>{acc.creditorName}</TableCell>
              <TableCell>{acc.creditorIBAN}</TableCell>
              <TableCell>{acc.creditorBIC}</TableCell>
              <TableCell>{acc.isMain ? "Ja" : "Nein"}</TableCell>
              <TableCell>
                <Button
                  variant="outlined"
                  onClick={() => onEdit(acc)}
                  sx={{ mr: 1 }}
                >
                  Bearbeiten
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => onMarkMain(acc._id)}
                  disabled={acc.isMain}
                  sx={{ mr: 1 }}
                >
                  Hauptkonto
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => onDelete(acc._id)}
                >
                  Löschen
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}
